import Component from 'flarum/common/Component';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
import Link from 'flarum/common/components/Link';
import app from 'flarum/forum/app';
import sectionName from '../utils/sections';

export default class ParticipantsList extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.expanded = false;
  }

  view() {
    const event = this.attrs.event;
    const rsvps = event.rsvps() || [];

    const sections = JSON.parse(app.forum.attribute('florCariocaSections') || '[]');
    const sectionOrder = Object.fromEntries(sections.map((s, i) => [s.id, i]));
    const bySection = (a, b) => (sectionOrder[a.section()] ?? Infinity) - (sectionOrder[b.section()] ?? Infinity);

    const attending = rsvps.filter((r) => r.status() === 'attending').sort(bySection);
    const notAttending = rsvps.filter((r) => r.status() === 'not_attending').sort(bySection);
    const membersWithoutResponse = event.membersWithoutResponse() || [];

    const totalCount = attending.length + notAttending.length + membersWithoutResponse.length;

    if (totalCount === 0) {
      return (
        <div className="ParticipantsList ParticipantsList--empty">
          <p>{app.translator.trans('florcarioca-rsvp.forum.participants.no_participants')}</p>
        </div>
      );
    }

    return (
      <div className="ParticipantsList">
        <button
          className="ParticipantsList-toggle Button"
          onclick={() => {
            this.expanded = !this.expanded;
          }}
        >
          <i className={`fas fa-chevron-${this.expanded ? 'up' : 'down'}`}></i>
          {' '}
          {app.translator.trans('florcarioca-rsvp.forum.participants.toggle', {
            count: totalCount,
          })}
        </button>

        {this.expanded && (
          <div className="ParticipantsList-content">
            {attending.length > 0 && (
              <div className="ParticipantsList-section ParticipantsList-section--attending">
                <h4>
                  <i className="fas fa-check-circle"></i>
                  {' '}
                  {app.translator.trans('florcarioca-rsvp.forum.participants.attending', {
                    count: attending.length,
                  })}
                </h4>
                <ul className="ParticipantsList-list">
                  {attending.map((rsvp) => this.renderParticipant(rsvp))}
                </ul>
              </div>
            )}

            {notAttending.length > 0 && (
              <div className="ParticipantsList-section ParticipantsList-section--not-attending">
                <h4>
                  <i className="fas fa-times-circle"></i>
                  {' '}
                  {app.translator.trans('florcarioca-rsvp.forum.participants.not_attending', {
                    count: notAttending.length,
                  })}
                </h4>
                <ul className="ParticipantsList-list">
                  {notAttending.map((rsvp) => this.renderParticipant(rsvp))}
                </ul>
              </div>
            )}

            {membersWithoutResponse.length > 0 && (
              <div className="ParticipantsList-section ParticipantsList-section--no-response">
                <h4>
                  <i className="fas fa-question-circle"></i>
                  {' '}
                  {app.translator.trans('florcarioca-rsvp.forum.participants.no_response', {
                    count: membersWithoutResponse.length,
                  })}
                </h4>
                <ul className="ParticipantsList-list">
                  {membersWithoutResponse.map((member) => this.renderMember(member))}
                </ul>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  renderParticipant(rsvp) {
    const user = rsvp.user();
    if (!user) return null;

    const sectionName = this.getSectionName(rsvp.section());

    return (
      <li className="ParticipantsList-item">
        <Link href={app.route.user(user)} className="ParticipantsList-user">
          {avatar(user, { className: 'ParticipantsList-avatar' })}
          <span className="ParticipantsList-name">{rsvp.masqueradeName() || username(user)}</span>
          <span className="ParticipantsList-username">@{user.username()}</span>
        </Link>

        {sectionName && (
          <span
            className="ParticipantsList-section-badge"
            style={{ backgroundColor: this.getSectionColor(rsvp.section()) }}
          >
            {sectionName}
          </span>
        )}

        {rsvp.comment() && (
          <span className="ParticipantsList-comment" title={rsvp.comment()}>
            <i className="fas fa-comment"></i>
            {rsvp.comment()}
          </span>
        )}
      </li>
    );
  }

  renderMember(member) {
    return (
      <li className="ParticipantsList-item">
        <Link href={app.route('user', { username: member.username })} className="ParticipantsList-user">
          {member.avatarUrl ? (
            <img src={member.avatarUrl} className="ParticipantsList-avatar Avatar" alt="" />
          ) : (
            <span className="ParticipantsList-avatar Avatar">{(member.masqueradeName || member.displayName).charAt(0).toUpperCase()}</span>
          )}
          <span className="ParticipantsList-name">{member.masqueradeName || member.displayName}</span>
          <span className="ParticipantsList-username">@{member.username}</span>
        </Link>
      </li>
    );
  }

  getSectionName(sectionId) {
    if (!sectionId) return null;
    const sections = JSON.parse(app.forum.attribute('florCariocaSections') || '[]');
    const section = sections.find((s) => s.id === sectionId);
    return section ? sectionName(section) : sectionId;
  }

  getSectionColor(sectionId) {
    if (!sectionId) return '#95a5a6';
    const sections = JSON.parse(app.forum.attribute('florCariocaSections') || '[]');
    const section = sections.find((s) => s.id === sectionId);
    return section ? section.color : '#95a5a6';
  }
}
